import { render } from "./letter-compose-step5.vue?vue&type=template&id=5ac2e53f"
import script from "./letter-compose-step5.vue?vue&type=script&lang=js"
export * from "./letter-compose-step5.vue?vue&type=script&lang=js"

import "./letter-compose-step5.vue?vue&type=style&index=0&id=5ac2e53f&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__